//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { xtLoginJsPath } from '@/config/project-config'
import { Toast} from 'vant';
import demandAddForm from '../modules/demandAddForm'
import md5 from 'js-md5'
export default {
  name: 'header',
  data() {
    let that = this
    return {
      sw:'',
      userInfo: this.$store.getters.getUserInfo, // 登录用户信息
      menus: this.$store.getters['home/getMenus'], // 菜单
      jgMenus: this.$store.getters['home/getJgMenus'], // 机构菜单
      menuActive: this.$store.getters['home/getMenuActive'], // 选中的菜单节点
      menuJgActive: this.$store.getters['home/getMenuJgActive'], // 选中的机构菜单节点
      menuStyle: this.$store.getters['home/getMenuStyle'], // 选中菜单样式
      selInputType: this.$store.getters['home/getSelInputType'], //0显示跳转页面的搜索框   1显示当前页面搜索的搜索框
      societyLogoUrl: this.$store.getters['home/getSocietyLogoUrl'], // 获取机构logo
      showMenuType: this.$store.getters['home/getShowMenuType'],//0显示平台头部按钮  1显示机构头部按钮
      commonTopName: this.$store.getters['home/getCommonTopName'],//获取上方背景图上显示的名称：公司名，或机构名
      commonTopNameFontSize: this.$store.getters['home/getCommonTopNameFontSize'],//头部显示公司名称文字大小
      commonTopSlogan: "",//获取上方背景图上显示的宣传语
      xtLoginJsPath,
      searchStr: "",//搜索条件字符串
      indexR:1,
      swiperOptionThumbsF: {
        autoplay: {
          disableOnInteraction: false,
          delay: 500,
        },
        observer:true,
        speed:500,
        pagination:'.swiper-pagination',
        paginationClickable: true,
        mousewheelControl: true,
        observeParents:true,
        loop: true,
        loopedSlides: 5,
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
				navigation: {
        	nextEl: '.swiper-button-next',
        	prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange:(event) => {
            event.activeIndex % 2 == 0 ? that.indexR = 2 : that.indexR = 1
            }
        },
      },
    };
  },
  created() {
    // alert("logo地址"+this.$store.getters['home/getSocietyLogoUrl'])
    // 获取当前使用的菜单样式
    this.fnGetMenuStyle()
    // 获取token信息
    this.fnGetToken()

  },
  activated () {
    // alert('新'+ this.$store.getters.getToken)
    // 获取token信息
    this.fnGetToken()
  },
    directives: {
    swiper: directive
  },
  components: { 
    demandAddForm ,    
    Swiper,
    SwiperSlide
    },
    destroyed(){
      window.clearInterval(this.sw)
    },
  methods: {
    showC(){
      window.clearInterval(this.sw)
    },
    showU(){
      window.clearInterval(this.sw)
      this.menuStyle == 0 ? this.goto() :''
    },
    goFirstPage () {
      this.$router.push({path: '/'})
    },
    goto (){
		if(this.swiperF != null && this.swiperF != undefined && this.swiperF.length > 0){
			this.sw = setInterval(() => {this.swiperF.slideNext()},5000)
		}
    },
    fnGoToPage(param) { // 跳转页面
      this.$store.dispatch('home/fnGoToPage', param).then(res=>{
        this.showMenuType = 0
        if(res != null && res != "" && res.indexOf("companyInfoList") < 0){
          this.$router.push({ path: res })
        }else if(res != null  && res != ""  &&  res.indexOf("companyInfoList") > -1){
           this.fnGotoSearchPage(2);
        }else{
          Toast("敬请期待")
        }
      })
    },
    handleBtnBannerLeftClicked () {
     this.swiperF.slidePrev()
    },
    handleBtnBannerRightClicked () {
     this.swiperF.slideNext()
    },
    fnGoToHomePage(){
      this.$router.push({path:'/home'})
    },
    fnGoToJgPage(param) { // 跳转机构页面
      this.$store.dispatch('home/fnGoToJgPage', param).then(res=>{
        this.showMenuType = 1
        if(res != null && res != "" && res.indexOf("companyInfoList") < 0){
          this.$router.push({ path: res })
        }else if(res != null  && res != ""  &&  res.indexOf("companyInfoList") > -1){
           this.fnGotoSearchPage(2);
        }else{
          Toast("敬请期待")
        }
      })
    },
    fnGetMenuStyle() { // 获取当前使用的菜单样式
      let path = this.$route.path
      this.$store.dispatch("home/fnGetMenuStyle", path).then(res=>{
        this.menuStyle = res
      })
    },
    //分辨率控制公司名称字体大小
    fnGetFontSizeNum(){
       // 分辨率控制字体大小
      if(window.screen.width <= 1367 && this.commonTopName.length > 26){
        return  "font-size: 30px;";
      }
      return "font-size: 36px;";
    },
    fnLogin() { // 登录
      this.$router.push({path:'/login'})
      // window.open('/login')
    },
    fnRegiste() { // 注册
      this.$router.push({path:'/registe'})
      // window.open('/registe')
    },
    fnJumpUserCenter() { //跳转用户中心
      this.fnGotoUserCenter({self_redirect: '0'})
    },
    fnJumpXmy(){//打开晓觅云新窗口
      window.open("http://www.xiaomecloud.com");
    },
    fnJumpCompanyCenter() { //跳转企业中心
      // alert(JSON.stringify(this.userInfo)) //多个企业没办法直接跳进去，企业中心index页


      // 获取token信息
      let token = this.fnGetToken()
      if(this.userInfo.ccUserBoList == null || this.userInfo.ccUserBoList.length == 0){
        Toast("当前账号无企业");
      }else if(this.userInfo.ccUserBoList.length == 1){//直接进用户中心index页面
        var state = {companyId: this.userInfo.ccUserBoList[0].companyId}
        this.fnGotoCompanyCenter({state:JSON.stringify(state)})
      }else{
        //如果是多个公司，跳转到选择公司页
        var state = {inType:'preweb',token:token}
        this.fnGotoCompanyCenter({state:JSON.stringify(state),second_redirect_uri:'chooseCompany'})
      }

    },
    fnGotoAppPubMain () {
      // 进入平台应用宣传页
      this.$router.push({path: '/appPubMain'});
    },
    //进入  入驻平台页面  即：用户中心企业信息列表页
    fnGotoUcFactory(){
      // this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'factory',state:'preweb'})
      //测试地址应该这样写 window.open("/quickEnterIn")   上线到正式之后如果有问题再调整为 window.open("/preweb/quickEnterIn")
      // window.open("/quickEnterIn")//测试
      window.open("/preweb/quickEnterIn")//正式
    },
    //进入  需求列表
    fnGotoDemandList(){
       // this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'factory',state:'preweb'})
      this.$router.push("/demand")
    },
    fnHandleBtnGotoCdrClicked () {
      // 进入AI报价演示页面
      localStorage.setItem("cdrDemoPage", "1");
      localStorage.removeItem("schemeInfo")
      this.$router.push({path: '/cdrConvert'});
    },
    // 跳转页面-用户中心  发布需求
    // fnGoToPageUcDemand() {
    //   // alert(`1`);
    //   this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:'preweb'})
    // },
    //跳转到找合作  搜索页直接查企业
    fnGotoSearchPage(selType){
      this.$router.push({path: '/search', query: {selType:selType}});
    },
    fnGotoOnlineYX(){
      Toast("敬请期待");
    },
    fnGotoOnlineAZ(){
      Toast("敬请期待");
    },
    fnGetToken() { // 获取token信息
      let token = this.$store.getters.getToken
      if(token == undefined || 'undefined' == token || token == null || 'null' == token || '' == token){ // token为空，重新赋值
        // token = this.$store.getters['user/getToken']
        token = this.getToken()
        this.$store.commit('setToken',token)
      }
    },
    getToken() { // 生成token
      let rod = Math.floor(Math.random() * 999999)
      let token = md5(rod + 'xtzz')
      return token
    },
    fnGoToSearch(seltype){
      if(seltype == 0){
        //跳转到搜索页，进去之后就显示当前页面搜索的搜索框了，所以setSelInputType 改成 1
        this.$store.commit('home/setSelInputType', 1);
        // this.$store.commit('home/setMenuStyle', 0);//为了显示灰色头部背景   2025数字云平台位置
        this.$router.push({path: '/search', query: {searchStr:this.searchStr}});
      }else{
        //当前页面搜索数据
        this.$parent.fnLoadDataPage();
      }
    },
    fnLogout () { // 退出
      this.$router.push({ path: '/logout' })
    },
    fnSetUserInfo (user) {
      this.userInfo = user
    },
    localStorageListener () {
      const _this = this;
      window.addEventListener("storage", function (e) {
        if (e.key && e.key == "alreadyLogin" && e.newValue) {
          _this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
          if(_this.userInfo == null) {
            _this.userInfo = {}
          } else {
            // console.log("登录登录登录")
            _this.$store.commit('setUserInfo',_this.userInfo)
            if(_this.userInfo.token != undefined && _this.userInfo.token != 'undefined' && _this.userInfo.token != null && _this.userInfo.token != '' && _this.userInfo.token != 'null') {
              _this.$store.commit('setToken',_this.userInfo.token)
            }
          }
        }
      });
    },
    handleSaveDemandSuccess () {
      // this.fnLoadUserDemandList()
    },
    handleLognSucccess (userInfo) {
      this.$refs.fnSetUserInfo(userInfo)
    },
    fnSetCommonTopName(commonTopName){
      if(window.screen.width <= 1367 && commonTopName.length > 6){
          this.commonTopNameFontSize ="font-size: 30px;";
      }else{
          this.commonTopNameFontSize ="font-size: 36px;";
      }
      this.commonTopName = commonTopName;
    },
    fnSetCommonTopSlogan(commonTopSlogan){
      this.commonTopSlogan = commonTopSlogan;
    }
  },
  mounted() {
    this.localStorageListener();
    if(this.menuStyle == 0 && this.$route.path != "/companyDetailNew" && this.$route.path != "/societyIndex"){
      this.goto()
    } else{
      window.clearInterval(this.sw)
    }

  },
  computed: {
    userLogin() {
      return this.$store.state.userInfo
    },
	swiperF() {
		if(this.$refs != undefined && this.$refs.swiperTopF != undefined){
			return this.$refs.swiperTopF.$swiper
		}else{
			return []
		}
      
    }
  },
  watch: {
    userLogin(data, val) {
      this.userInfo = data
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/header/header.vue